import { render, staticRenderFns } from "./6.vue?vue&type=template&id=206078c3&scoped=true"
var script = {}
import style0 from "./6.vue?vue&type=style&index=0&id=206078c3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "206078c3",
  null
  
)

export default component.exports